/* Standalone adapter for the existing Japan firmware section. */
if (!customElements.get('anbernic-firmware')) {
(() => {

    /**
     * 从固件标签中提取版本号。
     * 示例：RG 35XXPro-V1.0.5-EN16GB-260522 -> V1.0.5
     * 日期、容量和语言等后缀不会参与版本分组。
     */
    function getFirmwareVersion(label) {
        var match = String(label || '').match(/V\s*(\d+(?:\.\d+)+)/i);
        return match ? 'V' + match[1] : '';
    }

    function initFirmwareVersionSwitchers(root) {
        var scope = root || document;
        var textColumns = scope.querySelectorAll('.fw-text-col');

        textColumns.forEach(function(container) {
            if (container.getAttribute('data-fw-version-ready') === 'true') return;

            var firmwareItems = Array.from(container.querySelectorAll('.fw-version-item'));
            if (firmwareItems.length === 0) return;

            var versions = [];
            firmwareItems.forEach(function(item) {
                var version = getFirmwareVersion(item.getAttribute('data-firmware-label') || item.textContent);
                item.setAttribute('data-firmware-version', version);
                if (version && versions.indexOf(version) === -1) {
                    versions.push(version);
                }
            });

            // 没有识别到 V1.0.5 这类版本号时，保持原来的展示方式。
            if (versions.length === 0) return;

            // 后台固件列表按“最新在前”维护，只展示前 4 个不同版本。
            // 第 5 个及更旧版本不会生成切换按钮，对应的下载项也会隐藏。
            versions = versions.slice(0, 4);

            var switcher = document.createElement('div');
            switcher.className = 'fw-version-switcher';
            switcher.setAttribute('role', 'tablist');
            switcher.setAttribute('aria-label', 'ファームウェアのバージョン');

            function showVersion(selectedVersion) {
                firmwareItems.forEach(function(item) {
                    var itemVersion = item.getAttribute('data-firmware-version');
                    // 未识别到版本号的项目作为通用内容，在每个版本页中保留。
                    item.hidden = Boolean(itemVersion && itemVersion !== selectedVersion);
                });

                switcher.querySelectorAll('.fw-version-tab').forEach(function(button) {
                    var isActive = button.getAttribute('data-version') === selectedVersion;
                    button.classList.toggle('active', isActive);
                    button.setAttribute('aria-selected', isActive ? 'true' : 'false');
                    button.setAttribute('tabindex', isActive ? '0' : '-1');
                });
            }

            versions.forEach(function(version, index) {
                var button = document.createElement('button');
                button.type = 'button';
                button.className = 'fw-version-tab' + (index === 0 ? ' active' : '');
                button.textContent = version;
                button.setAttribute('data-version', version);
                button.setAttribute('role', 'tab');
                button.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
                button.setAttribute('tabindex', index === 0 ? '0' : '-1');
                button.addEventListener('click', function() {
                    showVersion(version);
                });
                switcher.appendChild(button);
            });

            switcher.addEventListener('keydown', function(event) {
                var buttons = Array.from(switcher.querySelectorAll('.fw-version-tab'));
                var index = buttons.indexOf(event.target);
                if (index < 0) return;
                if (event.key === 'ArrowRight') index = (index + 1) % buttons.length;
                else if (event.key === 'ArrowLeft') index = (index - 1 + buttons.length) % buttons.length;
                else if (event.key === 'Home') index = 0;
                else if (event.key === 'End') index = buttons.length - 1;
                else return;
                event.preventDefault();
                buttons[index].click();
                buttons[index].focus();
            });

            var blockNote = container.querySelector('.fw-block-note');
            if (blockNote) {
                container.insertBefore(switcher, blockNote);
            } else {
                container.appendChild(switcher);
            }

            container.setAttribute('data-fw-version-ready', 'true');
            showVersion(versions[0]);
        });
    }

    function toggleDualMode(container, direction) {
        if(!container) return;
        var panels = container.querySelectorAll('.fw-slide-panel');
        if(panels.length <= 1) return;
        var currentIndex = -1;
        for(var i = 0; i < panels.length; i++) {
            if(panels[i].style.display !== 'none') { currentIndex = i; break; }
        }
        if(currentIndex === -1) currentIndex = 0;
        panels[currentIndex].style.display = 'none';
        var nextIndex = currentIndex + direction;
        if(nextIndex >= panels.length) nextIndex = 0;
        if(nextIndex < 0) nextIndex = panels.length - 1;
        panels[nextIndex].style.display = 'block';
    }

    function initFirmwareSearch(root) {
        var searchInput = root.querySelector('[data-fw-id="fw-search-box"]');
        var searchBtn = root.querySelector('[data-fw-id="fw-search-btn"]');
        var tagsContainer = root.querySelector('[data-fw-id="fw-search-tags"]');
        var mainContentArea = root.querySelector('[data-fw-id="fw-main-content-area"]');
        var paginationContainer = root.querySelector('[data-fw-id="fw-pagination"]');
        
        var modalOverlay = root.querySelector('[data-fw-id="fw-custom-modal"]');
        var modalText = root.querySelector('[data-fw-id="fw-modal-text"]');
        var modalCloseBtn = root.querySelector('[data-fw-id="fw-modal-close-btn"]');
        
        if (!searchInput || !mainContentArea) return;

        initFirmwareVersionSwitchers(mainContentArea);
        
        var fwBlocks = Array.from(mainContentArea.querySelectorAll('.fw-grid'));
        var noResultsMsg = root.querySelector('[data-fw-id="fw-no-results-msg"]');
        
        var maxTagsLimit = parseInt(tagsContainer.getAttribute('data-max-tags')) || 5;
        var alertTemplate = tagsContainer.getAttribute('data-alert-msg') || '最多只能同时添加 [MAX] 个搜索型号。请先移除部分标签。';
        var itemsPerPage = parseInt(mainContentArea.getAttribute('data-items-per-page')) || 10;
        
        var activeTags = []; 
        var currentPage = 1;

        var previousModalFocus = null;
        function showCustomAlert(msg) {
            if(modalOverlay && modalText) {
                modalText.innerText = msg;
                previousModalFocus = document.activeElement;
                modalOverlay.classList.add('active');
                modalOverlay.setAttribute('aria-hidden', 'false');
                modalCloseBtn?.focus();
            } else {
                alert(msg); 
            }
        }

        function closeCustomAlert() {
            modalOverlay.classList.remove('active');
            modalOverlay.setAttribute('aria-hidden', 'true');
            previousModalFocus?.focus();
        }
        root.addEventListener('keydown', function(event) {
            if (!modalOverlay?.classList.contains('active')) return;
            if (event.key === 'Escape') { event.preventDefault(); closeCustomAlert(); }
            if (event.key === 'Tab') { event.preventDefault(); modalCloseBtn?.focus(); }
        });

        if(modalCloseBtn && modalOverlay) {
            modalCloseBtn.addEventListener('click', function() {
                closeCustomAlert();
            });
            modalOverlay.addEventListener('click', function(e) {
                if(e.target === modalOverlay) {
                    closeCustomAlert();
                }
            });
        }

        // 平滑滚动回列表顶部
        function scrollToTop() {
            var searchWrapper = root.querySelector('[data-fw-id="fw-top-search-wrapper"]');
            if(searchWrapper) {
                var rect = searchWrapper.getBoundingClientRect();
                var offset = window.pageYOffset || document.documentElement.scrollTop;
                window.scrollTo({
                    top: Math.max(0, rect.bottom + offset - (document.querySelector('.section-header')?.getBoundingClientRect().height || 0) - 24),
                    behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
                });
            }
        }

        function renderTags() {
            if (!tagsContainer) return;
            tagsContainer.innerHTML = '';
            
            activeTags.forEach(function(tag, index) {
                var tagEl = document.createElement('div');
                tagEl.className = 'fw-search-tag';
                tagEl.setAttribute('data-tag', tag);
                tagEl.innerHTML = '<span></span>' +
                                  '<button class="fw-search-tag-close" data-index="' + index + '" aria-label="Remove">' +
                                      '<svg viewBox="0 0 24 24"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>' +
                                  '</button>';
                tagEl.querySelector('span').textContent = tag;
                tagsContainer.appendChild(tagEl);
            });

            var closeBtns = tagsContainer.querySelectorAll('.fw-search-tag-close');
            closeBtns.forEach(function(btn) {
                btn.addEventListener('click', function() {
                    var idx = parseInt(this.getAttribute('data-index'));
                    activeTags.splice(idx, 1); 
                    currentPage = 1;
                    renderTags();
                    applySearchFilter();
                });
            });
        }

        function addTag(query) {
            if (query === '') return;
            
            var lowerQuery = query.toLowerCase();
            var exists = activeTags.some(function(t) { return t.toLowerCase() === lowerQuery; });
            
            if (!exists) {
                if (activeTags.length >= maxTagsLimit) {
                    var finalAlertMsg = alertTemplate.replace('[MAX]', maxTagsLimit);
                    showCustomAlert(finalAlertMsg);
                    return;
                }
                activeTags.push(query);
            }
            
            searchInput.value = ''; 
            currentPage = 1;
            renderTags();
            applySearchFilter();
        }

        // 渲染分页按钮
        function renderPagination(matchedBlocks) {
            var totalItems = matchedBlocks.length;
            var totalPages = Math.ceil(totalItems / itemsPerPage);
            
            if (currentPage > totalPages) currentPage = Math.max(1, totalPages);

            fwBlocks.forEach(function(block) {
                block.style.display = 'none';
            });

            var startIdx = (currentPage - 1) * itemsPerPage;
            var endIdx = startIdx + itemsPerPage;
            var visibleBlocks = matchedBlocks.slice(startIdx, endIdx);
            
            visibleBlocks.forEach(function(block) {
                block.style.display = 'flex';
            });

            if (!paginationContainer) return;
            paginationContainer.innerHTML = '';

            if (totalPages <= 1) return;

            var prevBtn = document.createElement('button');
            prevBtn.type = 'button';
            prevBtn.setAttribute('aria-label', '前のページ');
            prevBtn.className = 'fw-page-btn';
            prevBtn.innerHTML = '<svg viewBox="0 0 24 24"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></svg>';
            prevBtn.disabled = currentPage === 1;
            prevBtn.addEventListener('click', function() {
                if (currentPage > 1) {
                    currentPage--;
                    renderPagination(matchedBlocks);
                    scrollToTop();
                }
            });
            paginationContainer.appendChild(prevBtn);

            for (var i = 1; i <= totalPages; i++) {
                var pageBtn = document.createElement('button');
                pageBtn.className = 'fw-page-btn' + (i === currentPage ? ' active' : '');
                pageBtn.type = 'button';
                if (i === currentPage) pageBtn.setAttribute('aria-current', 'page');
                pageBtn.setAttribute('aria-label', i + ' ページ');
                pageBtn.textContent = i;
                
                (function(pageNum) {
                    pageBtn.addEventListener('click', function() {
                        if (currentPage !== pageNum) {
                            currentPage = pageNum;
                            renderPagination(matchedBlocks);
                            scrollToTop();
                        }
                    });
                })(i);
                
                paginationContainer.appendChild(pageBtn);
            }

            var nextBtn = document.createElement('button');
            nextBtn.type = 'button';
            nextBtn.setAttribute('aria-label', '次のページ');
            nextBtn.className = 'fw-page-btn';
            nextBtn.innerHTML = '<svg viewBox="0 0 24 24"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/></svg>';
            nextBtn.disabled = currentPage === totalPages;
            nextBtn.addEventListener('click', function() {
                if (currentPage < totalPages) {
                    currentPage++;
                    renderPagination(matchedBlocks);
                    scrollToTop();
                }
            });
            paginationContainer.appendChild(nextBtn);
        }

        function applySearchFilter() {
            var matchedBlocks = [];
            var matchedTags = new Set(); 

            fwBlocks.forEach(function(block) {
                if (activeTags.length === 0) {
                    matchedBlocks.push(block);
                    return;
                }

                var titles = block.querySelectorAll('.fw-title');
                var blockMatches = false;

                titles.forEach(function(titleEl) {
                    var titleTextRaw = titleEl.textContent.toLowerCase();
                    // 无视空格、横杠、下划线，用于极度模糊匹配
                    var titleNoSpace = titleTextRaw.replace(/[\s\-_]+/g, '');
                    
                    activeTags.forEach(function(tag) {
                        var tagNoSpace = tag.toLowerCase().replace(/[\s\-_]+/g, '');
                        var match1 = titleNoSpace.includes(tagNoSpace);
                        
                        var tagTerms = tag.toLowerCase().split(/\s+/).filter(Boolean);
                        var match2 = tagTerms.every(function(term) {
                            return titleTextRaw.includes(term);
                        });
                        
                        if (match1 || match2) {
                            blockMatches = true;
                            matchedTags.add(tag); 
                        }
                    });
                });

                if (blockMatches) {
                    matchedBlocks.push(block);
                } 
            });

            // 控制标签变灰逻辑
            if (activeTags.length > 0 && tagsContainer) {
                var renderedTags = tagsContainer.querySelectorAll('.fw-search-tag');
                renderedTags.forEach(function(tagEl) {
                    var originalTag = tagEl.getAttribute('data-tag');
                    if (!matchedTags.has(originalTag)) {
                        tagEl.classList.add('empty-tag');
                    } else {
                        tagEl.classList.remove('empty-tag');
                    }
                });
            }

            if (noResultsMsg) {
                if (matchedBlocks.length === 0 && fwBlocks.length > 0 && activeTags.length > 0) {
                    noResultsMsg.style.display = 'block';
                } else {
                    noResultsMsg.style.display = 'none';
                }
            }

            renderPagination(matchedBlocks);
        }

        searchInput.addEventListener('keypress', function(e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                addTag(searchInput.value.trim());
            }
        });

        if (searchBtn) {
            searchBtn.addEventListener('click', function(e) {
                e.preventDefault();
                addTag(searchInput.value.trim());
            });
        }
        
        root.querySelectorAll('[data-fw-dual-direction]').forEach(function(button) {
            button.type = 'button';
            button.addEventListener('click', function() {
                toggleDualMode(button.closest('.fw-text-col'), Number(button.dataset.fwDualDirection));
            });
        });
        applySearchFilter();
        return {
            revealBlock: function(blockId) {
                var index = fwBlocks.findIndex(function(block) { return block.dataset.fwBlockId === blockId; });
                if (index < 0) return false;
                activeTags = [];
                searchInput.value = '';
                currentPage = Math.floor(index / itemsPerPage) + 1;
                renderTags();
                applySearchFilter();
                return true;
            }
        };
    }

    var instances = new WeakMap();
    customElements.define('anbernic-firmware', class extends HTMLElement {
        connectedCallback() {
            queueMicrotask(() => {
                if (!this.isConnected || instances.has(this)) return;
                var state = initFirmwareSearch(this);
                if (state) instances.set(this, state);
            });
        }
        revealBlock(blockId) {
            return instances.get(this)?.revealBlock(blockId);
        }
    });
    document.addEventListener('shopify:block:select', function(event) {
        var blockId = event.detail?.blockId;
        if (!blockId) return;
        var closest = event.target.closest?.('anbernic-firmware');
        var roots = closest ? [closest] : document.querySelectorAll('anbernic-firmware');
        roots.forEach(function(root) { root.revealBlock(blockId); });
    });

})();
}
